// extracted by mini-css-extract-plugin
export default {"policy":"zllt4h_g","preHeader":"if4p5LdJ","nowrap":"MMFvqdE1"};